<template>
    <div class="container_inner_main">

        <div>
            <el-button type="primary" @click="clickToCreate">新建</el-button>
        </div>

        <el-table
                class="mtable"
                :data="administratorList"
                @row-click="onRowClick"
                border>

            <el-table-column min-width="10%" align="center" label="序号">
                <template slot-scope="scope">
                    {{ administratorList.indexOf(scope.row) + 1 }}
                </template>
            </el-table-column>
            <el-table-column min-width="35%" property="organs" label="机关"></el-table-column>
            <el-table-column min-width="35%" property="userName" label="账号"></el-table-column>
            <el-table-column min-width="20%" align="center" label="操作">
                <template slot-scope="scope">
                    <div>
                        <el-button class="uni_btn" icon="el-icon-delete" type="text" @click="deleteDepart(scope.row)">删除账号
                        </el-button>
                    </div>
                </template>
            </el-table-column>

        </el-table>

        <el-pagination
                background
                layout="total, prev, pager, next"
                v-if="administratorList.length"
                :total="administratorList.length"
                @current-change="handleCurrentChange"
                :current-page=checkInfo.currIndex
                :page-size=checkInfo.pageSize
                style="text-align: center"
        >
        </el-pagination>

        <el-dialog
                width="600px"
                :visible.sync="dialog_create"
                :lock-scroll="false"
                title="新建"
                :close-on-click-modal="false">

            <div class="container_inner_dialog">

                <div style="display: flex;align-items: center">
                    <div class="style_text_font">
<!--                        <span style="color: red">*</span>-->
                        机关名称
                    </div>
                    <el-select v-model="createInfo.organs" placeholder="请选择机关" class="my-input">
                        <el-option
                                v-for="item in organsList"
                                :key="item.id"
                                :label="item.organs"
                                :value="item.organs"
                                >
                        </el-option>
                    </el-select>


                </div>
                <div style="display: flex;align-items: center">
                    <div class="style_text_font">账号</div>
                    <el-input v-model="createInfo.userName" placeholder="请输入账号" class="my-input"></el-input>
                </div>

                <div style="display: flex;align-items: center">
                    <div class="style_text_font">密码</div>
                    <el-input v-model="createInfo.password" placeholder="请输入密码" class="my-input" show-password></el-input>
                </div>


                <div style="float: right">
                    <el-button type="primary" @click="upload">保存</el-button>
                    <el-button @click="cancelCreate">取消</el-button>
                </div>
            </div>
        </el-dialog>


<!--        <el-dialog-->
<!--                :visible.sync="dialog_edit"-->
<!--                :lock-scroll="false"-->
<!--                title="修改"-->
<!--                :close-on-click-modal="false">-->

<!--            <div class="container_inner_dialog">-->

<!--                <div style="display: flex;align-items: center">-->
<!--                    <div class="style_text_font">-->
<!--                        <span style="color: red">*</span>-->
<!--                        机关名称-->
<!--                    </div>-->
<!--                    <el-input v-model="editInfo.organs" placeholder="请输入名称" class="my-input" maxlength="20"-->
<!--                              show-word-limit></el-input>-->


<!--                </div>-->
<!--                <div style="display: flex;align-items: center">-->
<!--                    <div class="style_text_font">部门名称</div>-->
<!--                    <el-input v-model="editInfo.dpName" placeholder="请输入名称" class="my-input" maxlength="20"-->
<!--                              show-word-limit></el-input>-->
<!--                </div>-->


<!--                <div style="float: right">-->
<!--                    <el-button type="primary" @click="modify">修改</el-button>-->
<!--                    <el-button @click="cancelEdit">取消</el-button>-->
<!--                </div>-->
<!--            </div>-->
<!--        </el-dialog>-->
    </div>
</template>

<script>
    import {addAdmin, delAdmin, getAdminList, getOrgansList} from "@/api/api";
    import {Message} from "element-ui";
    import {formatDate, ssDateTimeFn} from "@/utils/time";
    // import getFormData from "@/utils/check-empty";
    export default {
        name: "administrator",
        data() {
            return {
                administratorList:[],
                organsList: [],
                total:0,
                checkInfo: {
                    currIndex: 1,
                    pageSize: 8
                },
                value:null,
                dialog_create: false,
                dialog_edit: false,


                currentInfo: '',
                createInfo: {
                    userName: '',
                    password: '',
                    organs:'',
                },
                editInfo: {
                    dpName: '',
                    organs: '',
                },
            }
        },
        created() {
            this.ritialInfo();
            this.ritialBaseData();
        },
        methods: {
            ritialInfo() {
                getAdminList(this.checkInfo).then(res => {
                    if (res.data.code === '0000') {
                        this.total=res.data.data.total;
                        this.administratorList = res.data.data.dataList;
                    } else {
                        Message.warning(res.data.message);
                        if (res.data.code==='10007'){
                            this.$router.push('/login');
                        }
                        // Message.warning(res.data.message);
                    }
                });
            },
            ritialBaseData(){
                let data = {
                    type: ""
                }
                getOrgansList(data).then(res => {
                    // console.log(res)
                    if (res.data.code === '0000') {
                        this.organsList = res.data.data;
                    } else {
                        Message.warning(res.data.message);
                        if (res.data.code==='10007'){
                            this.$router.push('/login');
                        }
                        // Message.warning(res.data.message);
                    }
                })
            },

            clickToCreate() {
                this.dialog_create = true
                this.createInfo = {
                    userName: '',
                    password: '',
                    organs:'',
                }
            },

            clickToEdit(row) {
                this.currentInfo = row
                this.editInfo.dpName = row.dpName
                this.editInfo.organs = row.organs
                this.dialog_edit = true
            },

            handleCurrentChange(val) {
                this.checkInfo.currIndex = val;
                this.ritialInfo()
            },

            cancelCreate() {
                this.dialog_create = false
            },
            cancelEdit() {
                this.dialog_edit = false
            },

            checkEmpty(aim) {
                return aim != null && aim !== '' && aim.length > 0
            },
            checkRepeatDpName(name, index) {
                let noRepeat = true;
                this.departList.forEach(item => {
                    if (item.dpName === name) {
                        if (index !== '') {
                            if (this.departList.indexOf(item) !== index) {
                                noRepeat = false;
                            }
                        } else {
                            noRepeat = false;
                        }

                    }
                })
                return noRepeat;
            },
            checkRepeatOrgName(name, index) {
                let noRepeat = true;
                this.departList.forEach(item => {
                    if (item.organs === name) {
                        if (index !== '') {
                            if (this.departList.indexOf(item) !== index) {
                                noRepeat = false;
                            }
                        } else {
                            noRepeat = false;
                        }

                    }
                })
                return noRepeat;
            },

            upload() {
                if (!this.checkEmpty(this.createInfo.organs)) {
                    this.$message.warning("请选择机关")
                    return
                }
                if (!this.checkEmpty(this.createInfo.userName)) {
                    this.$message.warning("请输入账号")
                    return
                }
                if (!this.checkEmpty(this.createInfo.password)) {
                    this.$message.warning("请输入密码")
                    return
                }
                // if (!this.checkRepeatOrgName(this.createInfo.organs)) {
                //     if (!this.checkRepeatDpName(this.createInfo.dpName)) {
                //         this.$message.warning("请不要输入重复的名称")
                //         return
                //     }
                // }
                // let user=localStorage.getItem('CurrentUser');
                // this.createInfo.createUser=user?user:'admin';
                // this.createInfo.createTime=ssDateTimeFn(new Date())
                console.log(this.createInfo)
                addAdmin(this.createInfo).then(res => {
                    if (res.data.code === '0000') {
                        Message.success(res.data.message);
                        this.dialog_create=false
                        this.ritialInfo()

                    } else {
                        Message.warning(res.data.message);
                        if (res.data.code==='10007'){
                            this.$router.push('/login');
                        }
                        // Message.warning(res.data.message);
                    }
                })
            },

            modify() {
                if (!this.checkEmpty(this.editInfo.organs)) {
                    this.$message.warning("请输入机关名称")
                    return
                }
                // if (!this.checkEmpty(this.editInfo.dpName)) {
                //   this.$message.warning("请输入部门名称")
                //   return
                // }
                if (!this.checkRepeatOrgName(this.editInfo.organs, this.departList.indexOf(this.currentInfo))) {
                    if (!this.checkRepeatDpName(this.editInfo.dpName, this.departList.indexOf(this.currentInfo))) {
                        this.$message.warning("请不要输入重复的部门名称")
                        return
                    }
                }

                this.currentInfo.organs = this.editInfo.organs
                this.currentInfo.dpName = this.editInfo.dpName
                updatePart(this.currentInfo).then(res => {
                    if (res.data.code === '0000') {
                        Message.success(res.data.message);
                        this.dialog_edit=false
                        this.ritialInfo()
                    }else {
                        Message.warning(res.data.message);
                        if (res.data.code==='10007'){
                            this.$router.push('/login');
                        }
                        // Message.warning(res.data.message);
                    }
                })
            },


            deleteDepart(row) {
                this.currentInfo = row
                this.$confirm('此操作将删除' + this.currentInfo.organs + '的分管理员账号，是否继续？', '删除账号', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delAdmin(this.currentInfo.id).then(res => {
                            if (res.data.code === '0000') {
                                this.ritialInfo()
                                Message.success(res.data.message);
                            } else {
                                Message.warning(res.data.message);
                                if (res.data.code==='10007'){
                                    this.$router.push('/login');
                                }
                                // Message.warning(res.data.message);
                            }
                        }
                    )
                }).catch(() => {

                })
            },
            onRowClick(row, event, colum) {
                this.currentInfo = row
            }
        }
    }
</script>

<style scoped>
    .container_inner_main {
        /*width: 100%;*/
        /*height: 100%;*/
    }

    .mtable {
        font-size: 17px;
        margin: 20px 0;
        width: 90%;
    }

    .my-input {
        font-size: 17px;
        width: 100%;
        margin: 10px;
    }

    .container_inner_dialog {
        margin-bottom: 20px;
    }

    /deep/ .uni_btn.el-button--text {
        color: red !important;
    }

    .style_text_font{
        font-size: 17px;
        width: 100px;
        text-align: right
    }
    /deep/.el-input{
    font-size: 17px;

    }

</style>
